import React, { useEffect, useState } from "react";
import "./videoPage.scss";
import { ApiGet } from "../../../../helpers/API/ApiData";
import Loader from "../../../../helpers/loader";
import dummyPDF from "../../../../assets/images/dummy.pdf";

const VideoPage = () => {
  const [loading, setLoading] = useState(false);
  const [VideoData, setVideoData] = useState([]);
  const location = window.location.href;
  const params = new URLSearchParams(new URL(location).search);
  const id = params.get("id");

  const getVideoById = async () => {
    if (id) {
      setLoading(true);
      try {
        let resp = await ApiGet(`video/getAllVideos?id=${id}`);
        setVideoData(resp?.data?.payload);
      } catch (error) {
        console.error("error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getVideoById();
  }, [id]);

  const handleDownloadLocalPdf = (file, fileName = "dummy.pdf") => {
    try {
      const blob = new Blob([file], { type: "application/pdf" });
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="akadime-page-details">
        <div className="sub-box">
          <div className="iframe-design">
            <iframe
              src={VideoData?.videoUrl}
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              title="Aurora Schulung"
            />
          </div>
          <div className="details">
            <h2>{VideoData?.maintitle}</h2>
            {/* <div className="left-alignment">
              <p>Weitere Informationen:</p>
              <h3>In dem Video</h3>
              <p>{VideoData?.innertext ?? "-"}</p>
              <div className="pdf-alignment">
                <svg
                  width="11"
                  height="14"
                  viewBox="0 0 11 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.4375 5.6H4.125C4.30734 5.6 4.4822 5.52625 4.61114 5.39497C4.74007 5.2637 4.8125 5.08565 4.8125 4.9C4.8125 4.71435 4.74007 4.5363 4.61114 4.40503C4.4822 4.27375 4.30734 4.2 4.125 4.2H3.4375C3.25516 4.2 3.0803 4.27375 2.95136 4.40503C2.82243 4.5363 2.75 4.71435 2.75 4.9C2.75 5.08565 2.82243 5.2637 2.95136 5.39497C3.0803 5.52625 3.25516 5.6 3.4375 5.6ZM3.4375 7C3.25516 7 3.0803 7.07375 2.95136 7.20503C2.82243 7.3363 2.75 7.51435 2.75 7.7C2.75 7.88565 2.82243 8.0637 2.95136 8.19497C3.0803 8.32625 3.25516 8.4 3.4375 8.4H7.5625C7.74484 8.4 7.9197 8.32625 8.04864 8.19497C8.17757 8.0637 8.25 7.88565 8.25 7.7C8.25 7.51435 8.17757 7.3363 8.04864 7.20503C7.9197 7.07375 7.74484 7 7.5625 7H3.4375ZM11 4.858C10.9928 4.79369 10.979 4.73034 10.9588 4.669V4.606C10.9257 4.53403 10.8816 4.46787 10.8281 4.41L6.70312 0.21C6.64629 0.155551 6.58131 0.110657 6.51063 0.0769999C6.4901 0.0740321 6.46927 0.0740321 6.44875 0.0769999C6.37891 0.0362189 6.30178 0.0100409 6.22188 0H2.0625C1.51549 0 0.990886 0.221249 0.604092 0.615076C0.217299 1.0089 0 1.54305 0 2.1V11.9C0 12.457 0.217299 12.9911 0.604092 13.3849C0.990886 13.7788 1.51549 14 2.0625 14H8.9375C9.48451 14 10.0091 13.7788 10.3959 13.3849C10.7827 12.9911 11 12.457 11 11.9V4.858ZM6.875 2.387L8.65563 4.2H7.5625C7.38016 4.2 7.2053 4.12625 7.07636 3.99497C6.94743 3.8637 6.875 3.68565 6.875 3.5V2.387ZM9.625 11.9C9.625 12.0857 9.55257 12.2637 9.42364 12.395C9.29471 12.5263 9.11984 12.6 8.9375 12.6H2.0625C1.88016 12.6 1.7053 12.5263 1.57636 12.395C1.44743 12.2637 1.375 12.0857 1.375 11.9V2.1C1.375 1.91435 1.44743 1.7363 1.57636 1.60503C1.7053 1.47375 1.88016 1.4 2.0625 1.4H5.5V3.5C5.5 4.05695 5.7173 4.5911 6.10409 4.98492C6.49089 5.37875 7.01549 5.6 7.5625 5.6H9.625V11.9ZM7.5625 9.8H3.4375C3.25516 9.8 3.0803 9.87375 2.95136 10.005C2.82243 10.1363 2.75 10.3143 2.75 10.5C2.75 10.6857 2.82243 10.8637 2.95136 10.995C3.0803 11.1263 3.25516 11.2 3.4375 11.2H7.5625C7.74484 11.2 7.9197 11.1263 8.04864 10.995C8.17757 10.8637 8.25 10.6857 8.25 10.5C8.25 10.3143 8.17757 10.1363 8.04864 10.005C7.9197 9.87375 7.74484 9.8 7.5625 9.8Z"
                    fill="black"
                  />
                </svg>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDownloadLocalPdf(dummyPDF)}
                >
                  Einführung .pdf download
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoPage;
